function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useRTL } from "../../hooks/useRTL";
import { cn } from "../../lib/utils";
import { Button, IconButton } from "../..";
import { Arrowchevron2LeftIcon, Arrowchevron2RightIcon, ArrowchevronLeftIcon, ArrowchevronRightIcon } from '@bfe/moly-icons';
import RcPagination from 'rc-pagination';
import React, { useEffect, useState } from 'react';
import { styles } from "../style/pagination";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var prefixCls = 'moly-pagination';

// 上下页模式
var StairsPagination = function StairsPagination(_ref) {
  var _ref$align = _ref.align,
    align = _ref$align === void 0 ? 'left' : _ref$align,
    disabledPrev = _ref.disabledPrev,
    disabledNext = _ref.disabledNext,
    prevText = _ref.prevText,
    nextText = _ref.nextText,
    _onClick = _ref.onClick,
    isMobile = _ref.isMobile;
  var isRTL = useRTL();
  return /*#__PURE__*/_jsxs("div", {
    className: cn(styles, "".concat(prefixCls, "-stairs align-").concat(align, " ").concat(isRTL ? 'rtl' : ''), _defineProperty({}, "".concat(prefixCls, "-mobile"), isMobile)),
    children: [/*#__PURE__*/_jsx(Button, {
      variant: "secondary",
      onClick: function onClick() {
        return _onClick && _onClick('prev');
      },
      disabled: disabledPrev,
      size: "small",
      children: prevText ? prevText : 'Prev'
    }), /*#__PURE__*/_jsx(Button, {
      variant: "secondary",
      onClick: function onClick() {
        return _onClick && _onClick('next');
      },
      disabled: disabledNext,
      size: "small",
      children: nextText ? nextText : 'Next'
    })]
  });
};

// Mobile
var MobilePagination = function MobilePagination(props) {
  var pageSize = props.pageSize,
    current = props.current,
    total = props.total,
    defaultCurrent = props.defaultCurrent,
    onChange = props.onChange,
    prevText = props.prevText,
    nextText = props.nextText,
    readonly = props.readonly;

  // @ts-ignore
  var totalPage = Math.ceil(total / pageSize);
  var page = defaultCurrent || current;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    currentPage = _useState2[0],
    setCurrentPage = _useState2[1];
  useEffect(function () {
    // @ts-ignore
    setCurrentPage(page);
  }, [page]);
  var handleGoPrev = function handleGoPrev() {
    if (onChange) {
      // @ts-ignore
      onChange(current - 1, pageSize);
    }
  };
  var handleGoNext = function handleGoNext() {
    if (onChange) {
      // @ts-ignore
      onChange(current + 1, pageSize);
    }
  };
  var handleChangePage = function handleChangePage(event) {
    var value = event.target.value;
    setCurrentPage(value);
  };
  var handleBlur = function handleBlur() {
    var targetValue = Number(currentPage);
    if (targetValue < 1) targetValue = 1;
    if (targetValue > totalPage) targetValue = totalPage;
    // @ts-ignore
    onChange(targetValue, pageSize);
  };
  return /*#__PURE__*/_jsxs("div", {
    className: cn(styles, "".concat(prefixCls, " ").concat(prefixCls, "-mobile"), _defineProperty({}, "".concat(prefixCls, "-readonly"), readonly)),
    children: [!readonly && /*#__PURE__*/_jsx(Button, {
      variant: "secondary",
      onClick: handleGoPrev,
      disabled: current === 1,
      size: "small",
      children: prevText ? prevText : 'Prev'
    }), /*#__PURE__*/_jsxs("div", {
      className: "mobile-pagination-text",
      children: [readonly ? /*#__PURE__*/_jsx("span", {
        children: page
      }) : /*#__PURE__*/_jsx("input", {
        type: "number",
        size: 1,
        value: currentPage,
        onChange: handleChangePage,
        onBlur: handleBlur
      }), /*#__PURE__*/_jsx("span", {
        children: "/"
      }), /*#__PURE__*/_jsx("span", {
        children: totalPage
      })]
    }), !readonly && /*#__PURE__*/_jsx(Button, {
      variant: "secondary",
      onClick: handleGoNext,
      disabled: current === totalPage,
      size: "small",
      children: nextText ? nextText : 'Next'
    })]
  });
};

// 极简 readonly
var SimpleReadOnlyPagination = function SimpleReadOnlyPagination(props) {
  var _props$pageSize = props.pageSize,
    pageSize = _props$pageSize === void 0 ? 10 : _props$pageSize,
    _props$current = props.current,
    current = _props$current === void 0 ? 1 : _props$current,
    total = props.total,
    defaultCurrent = props.defaultCurrent,
    onChange = props.onChange;
  var isRTL = useRTL();

  // @ts-ignore
  var totalPage = Math.ceil(total / pageSize);
  var page = defaultCurrent || current;
  var handleGoPrev = function handleGoPrev() {
    if (onChange) {
      // @ts-ignore
      onChange(current - 1, pageSize);
    }
  };
  var handleGoNext = function handleGoNext() {
    if (onChange) {
      // @ts-ignore
      onChange(current + 1, pageSize);
    }
  };
  return /*#__PURE__*/_jsxs("div", {
    className: cn(styles, "".concat(prefixCls, " ").concat(prefixCls, "-simple-readonly"), {
      'simple-readonly-small': props.size === 'small'
    }),
    children: [/*#__PURE__*/_jsx(IconButton, {
      size: "x-small",
      className: "prev-btn",
      onClick: handleGoPrev,
      disabled: current === 1,
      children: isRTL ? /*#__PURE__*/_jsx(ArrowchevronRightIcon, {}) : /*#__PURE__*/_jsx(ArrowchevronLeftIcon, {})
    }), /*#__PURE__*/_jsxs("div", {
      className: "pagination-text",
      children: [/*#__PURE__*/_jsx("span", {
        children: page
      }), /*#__PURE__*/_jsx("span", {
        children: "/"
      }), /*#__PURE__*/_jsx("span", {
        children: totalPage
      })]
    }), /*#__PURE__*/_jsx(IconButton, {
      size: "x-small",
      className: "next-btn",
      onClick: handleGoNext,
      disabled: current === totalPage,
      children: isRTL ? /*#__PURE__*/_jsx(ArrowchevronLeftIcon, {}) : /*#__PURE__*/_jsx(ArrowchevronRightIcon, {})
    })]
  });
};

// 分页器
var Pagination = function Pagination(props) {
  var isRTL = useRTL();
  var iconsProps = React.useMemo(function () {
    var ellipsis = /*#__PURE__*/_jsx("span", {
      className: "".concat(prefixCls, "-item-ellipsis"),
      children: "\u2022\u2022\u2022"
    });
    var prevIcon = props.simple ? /*#__PURE__*/_jsx(IconButton, {
      size: "x-small",
      children: isRTL ? /*#__PURE__*/_jsx(ArrowchevronRightIcon, {}) : /*#__PURE__*/_jsx(ArrowchevronLeftIcon, {})
    }) : /*#__PURE__*/_jsx("button", {
      className: "".concat(prefixCls, "-item-link"),
      type: "button",
      tabIndex: -1,
      children: isRTL ? /*#__PURE__*/_jsx(ArrowchevronRightIcon, {
        className: "relative "
      }) : /*#__PURE__*/_jsx(ArrowchevronLeftIcon, {
        className: "relative "
      })
    });
    var nextIcon = props.simple ? /*#__PURE__*/_jsx(IconButton, {
      size: "x-small",
      children: isRTL ? /*#__PURE__*/_jsx(ArrowchevronLeftIcon, {}) : /*#__PURE__*/_jsx(ArrowchevronRightIcon, {})
    }) : /*#__PURE__*/_jsx("button", {
      className: "".concat(prefixCls, "-item-link"),
      type: "button",
      tabIndex: -1,
      children: isRTL ? /*#__PURE__*/_jsx(ArrowchevronLeftIcon, {
        className: "relative "
      }) : /*#__PURE__*/_jsx(ArrowchevronRightIcon, {
        className: "relative "
      })
    });
    var jumpPrevIcon = /*#__PURE__*/_jsx("a", {
      className: "".concat(prefixCls, "-item-link"),
      children: /*#__PURE__*/_jsxs("div", {
        className: "".concat(prefixCls, "-item-container"),
        children: [isRTL ? /*#__PURE__*/_jsx(Arrowchevron2RightIcon, {
          className: "quick-jump relative"
        }) : /*#__PURE__*/_jsx(Arrowchevron2LeftIcon, {
          className: "quick-jump relative"
        }), ellipsis]
      })
    });
    var jumpNextIcon = /*#__PURE__*/_jsx("a", {
      className: "".concat(prefixCls, "-item-link"),
      children: /*#__PURE__*/_jsxs("div", {
        className: "".concat(prefixCls, "-item-container"),
        children: [isRTL ? /*#__PURE__*/_jsx(Arrowchevron2LeftIcon, {
          className: "quick-jump relative"
        }) : /*#__PURE__*/_jsx(Arrowchevron2RightIcon, {
          className: "quick-jump relative"
        }), ellipsis]
      })
    });
    return {
      prevIcon: prevIcon,
      nextIcon: nextIcon,
      jumpPrevIcon: jumpPrevIcon,
      jumpNextIcon: jumpNextIcon
    };
  }, [isRTL, props.simple]);
  var extendedClassName = cn(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, "".concat(prefixCls, "-align-").concat((props === null || props === void 0 ? void 0 : props.align) || 'left'), true), "".concat(prefixCls, "-mini"), (props === null || props === void 0 ? void 0 : props.size) === 'small'), "".concat(prefixCls, "-rtl"), isRTL), (props === null || props === void 0 ? void 0 : props.rootClassName) || '', true));
  var stairsProps = {
    align: props === null || props === void 0 ? void 0 : props.align,
    isMobile: props === null || props === void 0 ? void 0 : props.isMobile,
    prevText: props === null || props === void 0 ? void 0 : props.prevText,
    nextText: props === null || props === void 0 ? void 0 : props.nextText,
    disabledPrev: props === null || props === void 0 ? void 0 : props.disabledPrev,
    disabledNext: props === null || props === void 0 ? void 0 : props.disabledNext
  };

  // Mobile
  if (props.isMobile) {
    if (props.isStairs) {
      return /*#__PURE__*/_jsx(StairsPagination, _objectSpread(_objectSpread({}, stairsProps), {}, {
        onClick: props.onChangeStairs
      }));
    }
    return /*#__PURE__*/_jsx(MobilePagination, _objectSpread({}, props));
  }

  // 极简模式 且 readonly
  if (props.simple && props.readonly) {
    return /*#__PURE__*/_jsx(SimpleReadOnlyPagination, _objectSpread({}, props));
  }
  return props.isStairs ? /*#__PURE__*/_jsx(StairsPagination, _objectSpread(_objectSpread({}, stairsProps), {}, {
    onClick: props.onChangeStairs
  })) : /*#__PURE__*/_jsx(RcPagination, _objectSpread(_objectSpread({
    prefixCls: "moly-pagination",
    className: cn(styles, extendedClassName),
    locale: {
      jump_to: props.jumpToText || 'Go to',
      page: ''
    }
  }, iconsProps), props));
};
export { Pagination };